<app-simple-block-result
  [question]="question"
  [options]="question.block.checkboxes"
>
</app-simple-block-result>
